
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/customer-reviews",
      function () {
        return require("private-next-pages/customer-reviews.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/customer-reviews"])
      });
    }
  